import { ProgressBar } from "react-aria-components";
import { css } from "../../../../styled-system/css";
import { Flex } from "../../../../styled-system/jsx";
import { token } from "../../../../styled-system/tokens";

interface PerformanceProgressBarsProps {
  label?: string;
  current: number;
  previous: number;
  format: (value: number) => string;
  single?: boolean;
}

export const PerformanceProgressBars: React.FC<PerformanceProgressBarsProps> = ({
  label,
  current,
  previous,
  format,
  single = false,
}) => {
  const currentPercent = previous && previous > 0 ? Math.min((current / previous) * 100, 100) : 0;
  const previousPercent = previous > 0 ? 100 : 0;

  return (
    <Flex className={css({ display: "flex", width: "100%" })}>
      {label && <div className={css({ width: "100px", fontSize: "large" })}>{label}</div>}

      <div className={css({ display: "flex", flex: "1", gap: "1", flexDirection: "column" })}>
        <ProgressBar
          value={current}
          minValue={0}
          maxValue={previous}
          className={css({
            position: "relative",
            borderRadius: "md",
            height: "24px",
            backgroundColor: token("colors.gray.100"),
            overflow: "hidden",
          })}
        >
          <Flex
            className={css({
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              color: "white",
              fontSize: "small",
              backgroundColor: token("colors.trellisPalette.10"),
              transition: "width 0.3s ease",
              whiteSpace: "nowrap",
            })}
            style={{ width: `${currentPercent}%` }}
          >
            {current ? format(current) : "-"}
          </Flex>
        </ProgressBar>

        {!single && (
          <ProgressBar
            value={previous}
            minValue={0}
            maxValue={previous}
            className={css({
              position: "relative",
              borderRadius: "md",
              height: "24px",
              backgroundColor: token("colors.gray.100"),
              overflow: "hidden",
            })}
          >
            <Flex
              className={css({
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                color: "white",
                fontSize: "small",
                backgroundColor: token("colors.trellisPalette.2"),
                transition: "width 0.3s ease",
                whiteSpace: "nowrap",
              })}
              style={{ width: `${previousPercent}%` }}
            >
              {previous ? format(previous) : "-"}
            </Flex>
          </ProgressBar>
        )}
      </div>
    </Flex>
  );
};
